import React from 'react';

import {
  Container,
  ContainerText,
  Text,
  Titulo,
  ContainerTitulo,
} from './styles';
import { IconGoToBack } from '../../atoms/IconGoToBack';
import Main from '../../atoms/Main';

const Card = (): JSX.Element => {
  return (
    <>
      <Main>
        <ContainerText>
          <Text>REDEFINIÇÃO DE SENHA</Text>
        </ContainerText>
        <Container>
          <IconGoToBack />
          <ContainerTitulo>
            <Titulo>SENHA ALTERADA </Titulo>
            <Titulo>COM SUCESSO </Titulo>
          </ContainerTitulo>
        </Container>
      </Main>
    </>
  );
};

export default Card;
